import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * The one-sentence lead that opens each wizard step, sitting directly under the
 * header rule and above the fields. Per-step rather than one static dialog
 * description — it tells the user what *this* step is for.
 *
 * @example <app-step-lead text="Verbrauch und Strompreis bestimmen die Wirtschaftlichkeitsrechnung." />
 */
@Component({
  selector: 'app-step-lead',
  standalone: true,
  template: `
    <p class="mb-5 max-w-[62ch] text-xs leading-normal text-muted-foreground text-pretty">
      {{ text() }}
    </p>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StepLead {
  text = input.required<string>();
}
